module.exports = __webpack_public_path__ + "img/middleware.30a371f3.svg";